module.exports = __webpack_public_path__ + "img/dna_s.6b44564f.svg";